<!--
   Created by qing on 2020/12/29
   Des:
-->
<template>

  <ConfigContainer
    v-if="type === CONFIG_STATUS_TYPE__EDIT"
    :isPhone="isPhone"
    :value="current"
    :type="type">
    <template v-if="current.chartInfo">
      <component
        :key="current.chartInfo.chartId"
        ref="currentChart"
        :is="'control_' + current.chartInfo.chartType"
        :type="CHART_STATUS_TYPE__VIEW"
        :value="current.chartInfo">
      </component>
    </template>
  </ConfigContainer>
  <div v-else class="control-dashboard-container">
    <template v-if="current.chartInfo">
      <component
        :key="current.chartInfo.chartId"
        ref="currentChart"
        :is="'control_' + current.chartInfo.chartType"
        :type="CHART_STATUS_TYPE__VIEW"
        :value="current.chartInfo"
        :lastChart="lastChart"
        :nextChart="nextChart">
      </component>
    </template>
  </div>

</template>

<script>
  import ConfigContainer from './common/ConfigContainer'
  import control from '../../RyDashBoard/control/index'
  import {CHART_STATUS_TYPE__VIEW}  from '../../RyDashBoard/types'
  import {CONFIG_STATUS_TYPE__EDIT, CONFIG_TYPE__CONTACT_ME, CONFIG_TYPE__DASHBOARD} from "../type";
  import {arrayCompare} from "../../../assets/js/Untis";

  export default {
    props: {
      value: Object,
      type: Number,
      isPhone: {
        type: Boolean,
        default: false
      }
    },
    components: {
      ConfigContainer,
      ...control
    },
    data() {
      return {
        CONFIG_STATUS_TYPE__EDIT,
        CHART_STATUS_TYPE__VIEW,
        current: this.value,
      }
    },
    created() {
    },
    mounted() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.resize()
        }, 500)
      })
    },
    methods: {
      resize() {
        const chart = this.$refs.currentChart
        if (chart && chart.resize) {
          chart.resize()
        }
      },

      lastChart() {
        const y = this.current.y
        let lastChart = eachArr(this.current.parent, y)

        function eachArr(parent, y) {
          const chartList = parent.configList.filter(chart => chart.y + chart.h === y)
          if (!chartList || !chartList.length){
            return null
          }
          chartList.sort(arrayCompare("x",true))

          const chart = chartList[0]

          if ([CONFIG_TYPE__DASHBOARD].includes(chart.configType)) {
            return chart
          } else if ([CONFIG_TYPE__CONTACT_ME].includes(chart.configType)) {
            return null
          } else {
            const nextY = chart.y
            return eachArr(chart.parent, nextY)
          }
        }

        if (lastChart) {

          const parent = this.$parent.$parent.$parent.$parent
          let subChild = null
          let ownChild = null
          parent.$children.forEach(child => {
            if (child.$children && child.$children.length) {
              const sub = child.$children[0]

              if (sub) {
                sub.$children.forEach(child => {
                  if (child.$children && child.$children.length) {
                    const sub = child.$children[0]

                    if (sub.current && sub.current.configId === lastChart.configId) {
                      subChild = sub
                    }
                    if (sub.current && sub.current.configId === this.current.configId) {
                      ownChild = sub
                    }
                  }
                })
              }
            }
          })

          console.log('subChild', subChild, ownChild)
          if (subChild && subChild.$children && subChild.$children.length && subChild.$children[0].$children && subChild.$children[0].$children.length) {
            const el = subChild.$children[0].$children[0]
            if(el.actionFullScreen) {
              if (this.isWexinMini) {
                el.actionFullScreen(true)
              } else {
                el.actionFullScreen(false)
              }

              if (ownChild && ownChild.$children && ownChild.$children.length && ownChild.$children[0].$children && ownChild.$children[0].$children.length) {
                const ownEl = ownChild.$children[0].$children[0]
                if(ownEl.actionFullScreen) {
                  ownEl.actionFullScreen(false)
                }
              }

              const btmFilter = document.querySelector('#btmFilter')
              if (btmFilter) {
                btmFilter.style.display = 'none'
              }
            }
          }

        } else  {
          this.$toast.fail('已经是第一张图表了 ')
        }
      },
      nextChart() {
        const y = this.current.y + this.current.h
        let nextChart = eachArr(this.current.parent, y)

        function eachArr(parent, y) {
          const chartList = parent.configList.filter(chart => chart.y === y)
          if (!chartList || !chartList.length){
            return null
          }
          chartList.sort(arrayCompare("x",true))

          const chart = chartList[0]

          if ([CONFIG_TYPE__DASHBOARD].includes(chart.configType)) {
            return chart
          } else {
            const nextY = chart.y + chart.h
            return eachArr(chart.parent, nextY)
          }
        }

        if (nextChart) {

          const parent = this.$parent.$parent.$parent.$parent
          let subChild = null
          let ownChild = null
          parent.$children.forEach(child => {
            if (child.$children && child.$children.length) {
              const sub = child.$children[0]

              if (sub) {
                sub.$children.forEach(child => {
                  if (child.$children && child.$children.length) {
                    const sub = child.$children[0]

                    if (sub.current && sub.current.configId === nextChart.configId) {
                      subChild = sub
                    }
                    if (sub.current && sub.current.configId === this.current.configId) {
                      ownChild = sub
                    }
                  }
                })
              }
            }
          })

          if (subChild && subChild.$children && subChild.$children.length && subChild.$children[0].$children && subChild.$children[0].$children.length) {
            const el = subChild.$children[0].$children[0]

            if(el.actionFullScreen) {
              if (this.isWexinMini) {
                el.actionFullScreen(true)
              } else {
                el.actionFullScreen(false)
              }

              if (ownChild && ownChild.$children && ownChild.$children.length && ownChild.$children[0].$children && ownChild.$children[0].$children.length) {
                const ownEl = ownChild.$children[0].$children[0]
                if(ownEl.actionFullScreen) {
                  ownEl.actionFullScreen(false)
                }
              }

              const btmFilter = document.querySelector('#btmFilter')
              if (btmFilter) {
                btmFilter.style.display = 'none'
              }
            }
          }

        } else  {
          this.$toast.fail('已经是最后一张图表了 ')
        }
      }
    }
  }
</script>

<style lang="less">

  .control-dashboard-container {
    width: 100%;
    height: 100%;

    .ry-dashboard__view-item {
      height: 240px;
      background-color: #fff;
      margin: 10px;
      border-radius: 5px;
      position: relative;
    }

    .ry-dashboard__chart-container {
      min-height: 100%;
      overflow-x: hidden;
      width: 100%;

      .ry-dashboard__chart-item {
        border-radius: 10px;
        background-color: #ffffff;

        &:hover {
        }
      }

      .vue-grid-item.vue-grid-placeholder {
        background: #2D8cF0;
      }

      .vue-grid-item > .vue-resizable-handle {
        z-index: 3;
      }
    }


    .dashboard-empty__container,
    .dashboard-no-permissions__container {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #91A1B7;

      i {
        font-size: 28px;
        margin-bottom: 10px;
      }

      div {
        font-size: 14px;
      }
    }

    .loading-container {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      z-index: 100;

      .van-loading {
        width: 20px;
      }
    }
  }
</style>
